import euroDesktopRu from '../assets/europrotocol/euro-desktop.webp';
import euroDesktopKz from '../assets/europrotocol/euro-desktop-kz.webp';
import euroDesktopEn from '../assets/europrotocol/euro-desktop-en.webp';
import euroMobileRu from '../assets/europrotocol/euro-mobile.webp';
import euroMobileKz from '../assets/europrotocol/euro-mobile-kz.webp';
import euroMobileEn from '../assets/europrotocol/euro-mobile-en.webp';

const headerResources = {
  en: {
    translation: {
      'Personal account': 'Profile',
      'Insurance case': 'Insurance case',
      'Our products': 'Our products',
      useragent: 'Insurance agent',
      Home: 'Home',
      Market: 'Market',
      Bank: 'Bank',
      Investments: 'Investments',
      Insurance: 'Insurance',
      Автострахование: 'Car insurance',
      Путешествия: 'Travel',
      Имущество: 'Property',
      Здоровье: 'Health',
      'ОГПО ВТС': 'CICL VO',
      КАСКО: 'CASCO',
      'ДГПО авто': 'VCLI',
      'Ответственность перевозчика перед пассажирами':
        'Liability of carriers to passengers',
      'За границу': 'Abroad',
      'Квартира/Дом': 'House/Apartment',
      'Ответственность перед соседями': 'Responsibility towards neighbours',
      'Страхование от несчастного случая': 'Accident insurance',
      'Страхование спортсменов': "Sportsmen's insurance",
      'Медицинское страхование нерезидентов':
        'Health insurance for non-residents',
      'Страхование детей от несчастного случая':
        'Children´s Accident Insurance',
      Slogan: 'We protect everything that is precious to you',
      Telegram: 'Contact us in Telegram',
      Whatsapp: 'Contact us in WhatsApp',
      'Free call': 'free',
      online: 'Apply Online',
      earthquake: 'Earthquake / natural disasters...',
      'static.header.title1': 'For business',
      'static.header.title2': 'FAQ',
      'static.header.subtitle1': 'Liability of owners of dangerous objects',
      'static.header.subtitle2': 'Mandatory environmental insurance',
      'static.header.subtitle3': 'Business Insurance',
      'flutter.bottomBar.home': 'Home',
      'flutter.bottomBar.buy': 'Buy',
      'flutter.bottomBar.contacts': 'Contacts',
      'flutter.bottomBar.profile': 'Profile',
      'header.promotion1.title': 'Compulsary insurance (CICL VO) promotion',
      'header.promotion1.text1':
        'When buying a policy online, you have the opportunity to choose one of our Promotional offers:',
      'header.promotion1.text2': 'Guaranteed prize - 10 liters of AI-92;',
      'header.promotion1.text3':
        'Guaranteed prize - technical assistance on the road;',
      'header.promotion1.text4':
        'Participation in the weekly raffle of valuable prizes (the winner is given to choose from a smartphone, an electric scooter or a set of tires).',
      'header.promotion1.text5': 'Guaranteed prize - Technical Inspection;',
      'button.details': 'View details',
      nearOffice: 'You can get other insurance conditions by contacting ',
      'nearOffice.button': 'the nearest office',
      paid: 'Paid to customers in 2025',
      europrotocolDesktop: euroDesktopEn,
      europrotocolMobile: euroMobileEn,
      'Код подтверждения успешно отправлен на телефон':
        'Код подтверждения успешно отправлен на телефон',
      'Выберите способ оплаты': 'Выберите способ оплаты',
      'Оплата через систему Kaspi.kz': 'Оплата через систему kaspi.kz',
      'Оплата через карту любого банка': 'Оплата через карту любого банка',
      'Оплата через систему Qiwi': 'Оплата через систему Qiwi',
      'Kaspi.kz через другой номер телефона':
        'Kaspi.kz через другой номер телефона',
      'Карта любого банка': 'Карта любого банка',
      'Не удалось получить статус оплаты': 'Не удалось получить статус оплаты',
      'Вы можете закрыть эту страницу по завершению оплаты придет уведомление в WhatsApp или SMS':
        'Вы можете закрыть эту страницу по завершению оплаты придет уведомление в WhatsApp или SMS',
      'Ожидаем оплату, просим вас подождать':
        'Ожидаем оплату, просим вас подождать',
      'Поздравляем, полис успешно оформлен!':
        'Поздравляем, полис успешно оформлен!',
      'Вам выставлен счет на оплату в приложении Kaspi.kz':
        'Вам выставлен счет на оплату в приложении Kaspi.kz',
      'Номер заказа': 'Номер заказа',
      'Статус оплаты': 'Статус оплаты',
      Оплачен: 'Оплачен',
      'Ожидание оплаты': 'Ожидание оплаты',
      Обновить: 'Обновить',
      'Посмотреть полис': 'Посмотреть полис',
      'Перед оплатой полиса предлагаем принять участие в опросе для оценки нашего сервиса':
        'Перед оплатой полиса предлагаем принять участие в опросе для оценки нашего сервиса',
      Отлично: 'Отлично',
      Хорошо: 'Хорошо',
      Плохо: 'Плохо',
      'Спасибо, за то что выбираете нас!': 'Спасибо, за то что выбираете нас!',
      Отправить: 'Отправить',
      'Почему Вы решили купить полис на нашем сайте?':
        'Почему Вы решили купить полис на нашем сайте?',
      'Благодаря интернет-рекламе': 'Благодаря интернет-рекламе',
      'По совету родных или друзей': 'По совету родных или друзей',
      'рекомендовал менеджер': 'Рекомендовал менеджер',
      'воспользовались приложением Alatau City Bank':
        'Воспользовались приложением Alatau City Bank',
      'подписаны в Instagram, Facebook': 'Подписаны в Instagram, Facebook',
      'Как давно Вы являетесь клиентом нашей компании?':
        'Как давно Вы являетесь клиентом нашей компании?',
      'Менее одного года': 'Менее одного года',
      'более одного года': 'Более одного года',
      'Как Вы оцениваете сервисное обслуживание в компании?':
        'Как Вы оцениваете сервисное обслуживание в компании?',
      'Код подтверждения уже отправлен, время повторной отправки ещё не наступило':
        'Код подтверждения уже отправлен, время повторной отправки ещё не наступило',
      'Иные виды страхования': 'Иные виды страхования',
    },
  },
  kz: {
    translation: {
      'Personal account': 'Кабинет',
      'Insurance case': 'Сақтандыру жағдайы',
      useragent: 'Агент',
      'Our products': 'Біздің өнімдер',
      Home: 'Басты бет',
      Market: 'Дүкен',
      Bank: 'Банк',
      Investments: 'Инвестициялар',
      Insurance: 'Сақтандыру',
      Автострахование: 'Автосақтандыру',
      Путешествия: 'Саяхаттау',
      Имущество: 'Мүлік',
      Здоровье: 'Денсаулық',
      'ОГПО ВТС': 'ОГПО ВТС',
      КАСКО: 'КАСКО',
      'ДГПО авто': 'Авто АҚЖЕС',
      'Ответственность перевозчика перед пассажирами':
        'Тасымалдаушының жолаушылар алдындағы жауапкершілігі',
      'За границу': 'Шетелге',
      'Квартира/Дом': 'Пәтер/Үй',
      'Ответственность перед соседями': 'Көршілердің алдындағы жауапкершілік',
      'Страхование от несчастного случая': 'Жазатайым жағдайдан сақтандыру',
      'Страхование спортсменов': 'Спортшыларды сақтандыру',
      'Медицинское страхование нерезидентов':
        'Бейрезиденттерді медициналық сақтандыру',
      'Страхование детей от несчастного случая':
        'Балаларды жазатайым жағдайлардан сақтандыру',
      Slogan: 'Біз сіз үшін құнды нәрсенің бәрін қорғаймыз',
      Telegram: 'Telegram-ға жазыңыз',
      Whatsapp: 'WhatsApp-қа жазыңыз',
      'Free call': 'тегін',
      online: 'Онлайн рәсімдеу',
      earthquake: 'Жер сілкінісі / табиғи апаттар...',
      'static.header.title1': 'Бизнеске',
      'static.header.title2': 'FAQ',
      'static.header.subtitle1': 'Қауіпті объектілер иелерінің жауапкершілігі',
      'static.header.subtitle2': 'Міндетті экологиялық сақтандыру',
      'static.header.subtitle3': 'Бизнеске арналған сақтандыру',
      'flutter.bottomBar.home': 'Бас бет',
      'flutter.bottomBar.buy': 'Сатып алу',
      'flutter.bottomBar.contacts': 'Контактілер',
      'flutter.bottomBar.profile': 'Кабинет',
      'header.promotion1.title': 'Міндетті автосақтандыру (ОГПО ВТС) акциясы',
      'header.promotion1.text1':
        'Полисті онлайн сатып алу кезінде сізде біздің жарнамалық ұсыныстарымыздың бірін таңдауға мүмкіндігіңіз бар:',
      'header.promotion1.text2': 'Кепілдендірілген сыйлық - 10 литр АИ-92;',
      'header.promotion1.text3':
        'Кепілдендірілген сыйлық - жолдағы техникалық көмек;',
      'header.promotion1.text4':
        'Бағалы сыйлықтардың апта сайынғы ұтыс ойынына қатысу (жеңімпазға таңдауға смартфон, электр самокаты немесе шиналар жиынтығы беріледі).',
      'header.promotion1.text5': 'Кепілдендірілген сыйлық - Техникалық байқау;',
      'button.details': 'Өнім туралы толығырақ',
      nearOffice: 'Сақтандыруды өзгеше шарттармен жақын ',
      'nearOffice.button': 'жердегі кеңсеге',
      nearOfficeKZ: ' хабарласу арқылы алуға болады',
      paid: 'Клиенттерге 2025 жылы төленді',
      europrotocolDesktop: euroDesktopKz,
      europrotocolMobile: euroMobileKz,
      'Код подтверждения успешно отправлен на телефон':
        'Растау коды телефонға сәтті жіберілді',
      'Выберите способ оплаты': 'Төлем әдісін таңдаңыз',
      'Оплата через систему Kaspi.kz': 'Kaspi.kz жүйесі арқылы төлеу',
      'Оплата через карту любого банка':
        'Кез келген банктің картасы арқылы төлеу',
      'Оплата через систему Qiwi': 'Qiwi жүйесі арқылы төлеу',
      'Kaspi.kz через другой номер телефона':
        'Kaspi.kz (басқа телефон нөмірі арқылы)',
      'Карта любого банка': 'Кез келген банктің картасы',
      'Не удалось получить статус оплаты': 'Төлемнің күйін алу мүмкін болмады',
      'Вы можете закрыть эту страницу по завершению оплаты придет уведомление в WhatsApp или SMS':
        'Төлем аяқталғаннан кейін WhatsApp немесе SMS арқылы хабарлама аласыз, осы бетті жабуға болады',
      'Ожидаем оплату, просим вас подождать':
        'Төлемді күтеміз, өтінеміз, күтіңіз',
      'Поздравляем, полис успешно оформлен!':
        'Құттықтаймыз, полис сәтті рәсімделді!',
      'Вам выставлен счет на оплату в приложении Kaspi.kz':
        'Сізге Kaspi.kz қосымшасында төлем шоты жіберілді',
      'Номер заказа': 'Тапсырыс нөмірі',
      'Статус оплаты': 'Төлем мәртебесі',
      Оплачен: 'Төленді',
      'Ожидание оплаты': 'Төлем күтілуде',
      Обновить: 'Жаңарту',
      'Посмотреть полис': 'Полисті қарау',
      'Перед оплатой полиса предлагаем принять участие в опросе для оценки нашего сервиса':
        'Полистің ақысын төлемес бұрын, біздің қызметімізді бағалау үшін сауалнамаға қатысуды сұраймыз',
      Отлично: 'Тамаша',
      Хорошо: 'Жақсы',
      Плохо: 'Нашар',
      'Спасибо, за то что выбираете нас!':
        'Бізді таңдағаныңыз үшін алғыс білдіреміз!',
      Отправить: 'Жіберу',
      'Почему Вы решили купить полис на нашем сайте?':
        'Полисті неліктен біздің веб-сайт арқылы сатып алуды ұйғардыңыз?',
      'Благодаря интернет-рекламе': 'Интернеттегі жарнаманың арқасында',
      'По совету родных или друзей':
        'Туыстарымның немесе достарымның кеңесі бойынша',
      'рекомендовал менеджер': 'менеджер ұсынды',
      'воспользовались приложением Alatau City Bank':
        'Alatau City Bank қосымшасын пайдаландым',
      'подписаны в Instagram, Facebook':
        'Instagram, Facebook желілеріне жазылғанмым',
      'Как давно Вы являетесь клиентом нашей компании?':
        'Сіз қанша уақыттан бері біздің компанияның клиентісіз?',
      'Менее одного года': 'Бір жылға толмайды',
      'более одного года': 'бір жылдан астам',
      'Как Вы оцениваете сервисное обслуживание в компании?':
        'Біздің компанияның қызметін қалай бағалайсыз?',
      'Код подтверждения уже отправлен, время повторной отправки ещё не наступило':
        'Растау коды жіберілді, қайта жіберу уақыты әлі келген жоқ',
      'Иные виды страхования': 'Сақтандырудың басқа түрлері',
      'После оплаты ваш полис доступен для скачивания в вашем личном кабинете. Чтобы получить документ, пожалуйста, войдите в личный кабинет на нашем сайте и перейдите в раздел "Мои полисы"':
        'Төлегеннен кейін сіздің полисіңізді Жеке кабинетте жүктеуге болады. Құжатты алу үшін біздің сайттағы жеке кабинетке кіріп, "Менің полистерім" бөліміне өтіңіз',
    },
  },
  ru: {
    translation: {
      'Personal account': 'Кабинет',
      'Insurance case': 'Страховой случай',
      useragent: 'Стать агентом',
      'Our products': 'Наши продукты',
      Home: 'Главная',
      Market: 'Магазин',
      Bank: 'Банк',
      Investments: 'Инвестиции',
      Insurance: 'Страхование',
      Автострахование: 'Автострахование',
      Путешествия: 'Путешествия',
      Имущество: 'Имущество',
      Здоровье: 'Здоровье',
      'ОГПО ВТС': 'ОГПО ВТС',
      КАСКО: 'КАСКО',
      'ДГПО авто': 'ДГПО авто',
      'Ответственность перевозчика перед пассажирами':
        'Ответственность перевозчика перед пассажирами',
      'За границу': 'За границу',
      'Квартира/Дом': 'Квартира/Дом',
      'Ответственность перед соседями': 'Ответственность перед соседями',
      'Страхование от несчастного случая': 'Страхование от несчастного случая',
      'Страхование спортсменов': 'Страхование спортсменов',
      'Медицинское страхование нерезидентов':
        'Медицинское страхование нерезидентов',
      'Страхование детей от несчастного случая':
        'Страхование детей от несчастного случая',
      Slogan: 'Мы оберегаем все, что вы цените',
      Telegram: 'Написать в Telegram',
      Whatsapp: 'Написать в WhatsApp',
      'Free call': 'бесплатно',
      online: 'Оформить онлайн',
      earthquake: 'Землетрясение / стихийные бедствия...',
      'static.header.title1': 'Для бизнеса',
      'static.header.title2': 'FAQ',
      'static.header.subtitle1': 'ОГПО владельцев опасных объектов',
      'static.header.subtitle2': 'Обязательное экологическое страхование',
      'static.header.subtitle3': 'Страхование для бизнеса',
      'flutter.bottomBar.home': 'Главная',
      'flutter.bottomBar.buy': 'Купить',
      'flutter.bottomBar.contacts': 'Контакты',
      'flutter.bottomBar.profile': 'Кабинет',
      'header.promotion1.title':
        'Акция Обязательное автострахование (ОГПО ВТС)',
      'header.promotion1.text1':
        'При онлайн покупке полиса у вас есть возможность выбрать одно из наших Акционных предложений:',
      'header.promotion1.text2': 'Гарантированный приз  - 10 литров АИ-92;',
      'header.promotion1.text3': 'Гарантированный приз - техпомощь на дороге;',
      'header.promotion1.text4':
        'Участие в еженедельном розыгрыше ценных призов (на выбор победителю предоставляется смартфон, электросамокат или комплект шин).',
      'header.promotion1.text5': 'Гарантированный приз - техосмотр машины;',
      'button.details': 'Подробнее о продукте',
      nearOffice: 'Иные условия страхования вы сможете получить обратившись в ',
      'nearOffice.button': 'ближайший офис',
      paid: 'Выплатили клиентам в 2025 году',
      europrotocolDesktop: euroDesktopRu,
      europrotocolMobile: euroMobileRu,
      'Код подтверждения успешно отправлен на телефон':
        'Код подтверждения успешно отправлен на телефон',
      'Выберите способ оплаты': 'Выберите способ оплаты',
      'Оплата через систему Kaspi.kz': 'Оплата через систему kaspi.kz',
      'Оплата через карту любого банка': 'Оплата через карту любого банка',
      'Оплата через систему Qiwi': 'Оплата через систему Qiwi',
      'Kaspi.kz через другой номер телефона':
        'Kaspi.kz через другой номер телефона',
      'Карта любого банка': 'Карта любого банка',
      'Не удалось получить статус оплаты': 'Не удалось получить статус оплаты',
      'Вы можете закрыть эту страницу по завершению оплаты придет уведомление в WhatsApp или SMS':
        'Вы можете закрыть эту страницу по завершению оплаты придет уведомление в WhatsApp или SMS',
      'Ожидаем оплату, просим вас подождать':
        'Ожидаем оплату, просим вас подождать',
      'Поздравляем, полис успешно оформлен!':
        'Поздравляем, полис успешно оформлен!',
      'Вам выставлен счет на оплату в приложении Kaspi.kz':
        'Вам выставлен счет на оплату в приложении Kaspi.kz',
      'Номер заказа': 'Номер заказа',
      'Статус оплаты': 'Статус оплаты',
      Оплачен: 'Оплачен',
      'Ожидание оплаты': 'Ожидание оплаты',
      Обновить: 'Обновить',
      'Посмотреть полис': 'Посмотреть полис',
      'Перед оплатой полиса предлагаем принять участие в опросе для оценки нашего сервиса':
        'Перед оплатой полиса предлагаем принять участие в опросе для оценки нашего сервиса',
      Отлично: 'Отлично',
      Хорошо: 'Хорошо',
      Плохо: 'Плохо',
      'Спасибо, за то что выбираете нас!': 'Спасибо, за то что выбираете нас!',
      Отправить: 'Отправить',
      'Почему Вы решили купить полис на нашем сайте?':
        'Почему Вы решили купить полис на нашем сайте?',
      'Благодаря интернет-рекламе': 'Благодаря интернет-рекламе',
      'По совету родных или друзей': 'По совету родных или друзей',
      'рекомендовал менеджер': 'Рекомендовал менеджер',
      'воспользовались приложением Alatau City Bank':
        'Воспользовались приложением Alatau City Bank',
      'подписаны в Instagram, Facebook': 'Подписаны в Instagram, Facebook',
      'Как давно Вы являетесь клиентом нашей компании?':
        'Как давно Вы являетесь клиентом нашей компании?',
      'Менее одного года': 'Менее одного года',
      'более одного года': 'Более одного года',
      'Как Вы оцениваете сервисное обслуживание в компании?':
        'Как Вы оцениваете сервисное обслуживание в компании?',
      'Код подтверждения уже отправлен, время повторной отправки ещё не наступило':
        'Код подтверждения уже отправлен, время повторной отправки ещё не наступило',
      'Иные виды страхования': 'Иные виды страхования',
      'После оплаты ваш полис доступен для скачивания в вашем личном кабинете. Чтобы получить документ, пожалуйста, войдите в личный кабинет на нашем сайте и перейдите в раздел "Мои полисы"':
        'После оплаты ваш полис доступен для скачивания в вашем личном кабинете. Чтобы получить документ, пожалуйста, войдите в личный кабинет на нашем сайте и перейдите в раздел "Мои полисы"',
    },
  },
};

export default headerResources;
